'use client'

import { useTranslations } from 'next-intl'
import { isBulkUploadError } from '../services/bulkUploadServices'
import Paragraph from '@/shared/v2/shared/components/Paragraph'

type BulkUploadErrorProps = {
    error: unknown
}

function BulkUploadError({ error }: BulkUploadErrorProps) {
    const t = useTranslations('root.errors.bulkUpload')

    if (!error) return null

    let content: string

    if (isBulkUploadError(error)) {
        switch (error.code) {
            case 'MISSING_HEADERS':
                content = `${t('MISSING_HEADERS')} ${t('missingHeadersDetailed', {
                    headers: error.details?.missingHeaders?.join(', ') ?? ''
                })}`
                break
            case 'EMPTY_FILE':
                content = t('EMPTY_FILE')
                break
            case 'PARSING_ERROR':
                content = t('PARSING_ERROR')
                break
            case 'UNKNOWN_ERROR':
            default:
                content = t('UNKNOWN_ERROR')
                break
        }
    } else {
        content = t('UNKNOWN_ERROR')
    }

    return (
        <Paragraph data-testid="__bulk-upload-error__" color="negative" size={1}>
            {content}
        </Paragraph>
    )
}

export default BulkUploadError
